import { createTheme } from "@mui/material/styles";
import { red } from "@mui/material/colors";

// A custom theme for this app
const theme = createTheme({
  palette: {
    primary: {
      main: "#424242",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#2196f3",
    },
    error: {
      main: red.A400,
    },
  },
  components: {
    MuiContainer: {
      defaultProps: {
        maxWidth: "lg",
      },
    },
    //@ts-ignore
    MuiLoadingButton: {
      // styleOverrides: {
      //   contained: {
      //     borderRadius: 0,
      //     boxShadow: "none",
      //     textShadow: "0px 0px 2px white",
      //   },
      // },
      defaultProps: {
        variant: "contained",
        color: "primary",
      },
    },
    MuiButton: {
      // styleOverrides: {
      //   contained: {
      //     borderRadius: 0,
      //     boxShadow: "none",
      //     textShadow: "0px 0px 2px white",
      //   },
      // },
      defaultProps: {
        variant: "contained",
        color: "primary",
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          fontSize: "1.2rem",
          lineHeight: "1.2em",
          background: "white",
          paddingRight: 4,
        },
      },
    },
    MuiTextField: {
      defaultProps: { fullWidth: true },
    },
  },
});

export default theme;
